


















































































































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Subscription, { StripeInvoice, StripeUpcomingInvoice } from '../../../../../api/v2/models/subscription'
import { subscriptionState } from '../../../../stores/subscription'
import PremiumService, { SubscriptionCompare } from '../../../../../api/v2/models/pre_service'
import StripeToken from '../../../../../api/v2/models/stripe_token'
import { format } from 'date-fns'
import StripeElementCardPayComponent from '../../../atoms_molecules/StripeElementCardPay.vue'
import {userState} from "../../../../stores/user"
import api from '../../../../../api/v2/api'
import { calcTaxIncluded } from '../../../../utils/price'
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js'

@Component({
  components: {
    StripeElementCardPayComponent
  }
})

export default class ChangePlanPaymentConfirm extends Vue {
  subscription: Subscription | null = null
  targetPremiumService: PremiumService | null = null
  subscriptionCompared: SubscriptionCompare | null = null
  stripeUpcomingInvoice: StripeUpcomingInvoice | null = null
  stripeLastInvoice: StripeInvoice | null = null
  stripeToken: StripeToken | null = null
  stripeTokenId: string | null = null
  isLoading = true
  calcTaxIncluded = calcTaxIncluded
  stripePromise: Promise<Stripe | null> | null = null
  stripe: Stripe | null = null
  paymentIntentClientSecret: string | null = null
  paymentMethodCartSetup: any = null
  subscriptionIdCartSetup: string | null = null
  cardBrand: string = '';
  cardLast4: string = '';
  cardExpMonth: number | null = null;
  cardExpYear: number | null = null;
  subscriptionChangePlanId: string | null = null

  get user() {
    return userState.user
  }

  async mounted() {
    await this.initStripePromise();
  }

  async initStripePromise() {
    const stripeKey = typeof window !== 'undefined' && 'stripe_publishable_key' in window 
      ? (window as any).stripe_publishable_key
      : 'pk_test_51JTdp5BLyLEisqmg7jI53Eu2dMWbssUIo4Bcs69zI5ZybYLbAVJCwT5IuIYC6I9qzsIAFtyhnH1ReufLLPoBJMbM001cxeSv9D';

    try {
      this.stripePromise = loadStripe(stripeKey);
      this.stripe = await this.stripePromise;
      console.log('Stripe initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Stripe:', error);
    }
  }

  created() {
    this.getSubscription()
    this.getTargetPremiumService()
  }

  getSubscription() {
    subscriptionState.getSubscription(this.$route.params.subscriptionId as any).then((response) => {
      if (response) {
        this.subscription = response.subscription
        if (this.subscription.isStoped) {
          window.location.href = '/classroom/subscription/' + this.subscription.id
        }

        this.stripeUpcomingInvoice = response.stripeUpcomingInvoice || new StripeUpcomingInvoice({})
        this.stripeLastInvoice = response.stripeInvoices[0]
      }
    })
  }

  getTargetPremiumService() {
    subscriptionState
      .getTargetPremiumService(
        this.$route.params.subscriptionId as any,
        this.$route.query.targetPremiumServiceId as any
      )
      .then((response) => {
        if (response) {
          this.targetPremiumService = response
          this.subscriptionCompared = response.subscriptionCompare
          this.isLoading = false
        }
      })
  }

  openPaymentMethodCartSetup(paymentMethod) {
    this.paymentMethodCartSetup = paymentMethod;
  }
  openClientSecretCartSetup(clientSecret) {
    this.paymentIntentClientSecret = clientSecret;
  }
  openSubscriptionIdCartSetup(subscriptionId) {
    this.subscriptionIdCartSetup = subscriptionId;
  }
  updateCardDetails(cardDetails) {
    this.cardBrand = cardDetails.brand;
    this.cardLast4 = cardDetails.last4;
    this.cardExpMonth = cardDetails.exp_month;
    this.cardExpYear = cardDetails.exp_year;
    this.isLoading = true;

    window.location.reload(); // reload card
  }

  async submitPaymentConfirm() {
    this.isLoading = true;

    try {
      // Ensure Stripe is initialized
      if (!this.stripe) {
        // Try to initialize Stripe again if it failed before
        this.stripe = await this.stripePromise;
        if (!this.stripe) {
          throw new Error("Stripe couldn't be initialized. Please refresh and try again.");
        }
      }

      try {
        const response = await api.subscription.create(
          this.targetPremiumService.id,
          this.paymentMethodCartSetup,
          parseInt(this.subscriptionIdCartSetup || this.$route.params.subscriptionId)
        );

        console.log('Payment response:', response);

        if (response.data.paymentStatus !== "requires_confirmation" && response.data.paymentStatus !== "requires_action") {
          this.isLoading = false;
          this.$router.push(
            `/classroom/subscription/${this.$route.params.subscriptionId}/change-plan/completion?targetPremiumServiceId=${this.targetPremiumService?.id}`
          );
          return;
        }

        // Payment confirmation
        if (response.data.clientSecret) {
          console.log('Payment requires confirmation...', response.data.clientSecret, response.data.paymentMethodId);

          let confirmationResult;

          if (response.data.intent_type === 'setup') {
            confirmationResult = await this.stripe.confirmCardSetup(
              response.data.clientSecret,
              {
                payment_method: response.data.paymentMethodId
              }
            );
          } else {
            confirmationResult = await this.stripe.confirmCardPayment(
              response.data.clientSecret,
              {
                payment_method: response.data.paymentMethodId
              }
            );
          }

          const { error } = confirmationResult;

          if (error) {
            console.error("Stripe confirmation error:", error);
            throw new Error(error.message || "Payment confirmation failed");
          }

          this.subscriptionChangePlanId = response.data.subscriptionStripe;
          this.checkSubscriptionStatus();

          console.log('Payment confirmed successfully!');
          this.isLoading = false;
          this.$router.push(
            `/classroom/subscription/${this.$route.params.subscriptionId}/change-plan/completion?targetPremiumServiceId=${this.targetPremiumService?.id}`
          );
        } else {
          this.isLoading = false;
          throw new Error("Payment requires confirmation but no client secret was provided");
        }
      } catch (apiError) {
        this.isLoading = false;
        console.error("API Error:", apiError);
        throw apiError;
      }
    } catch (error) {
      this.isLoading = false;
      console.error("Payment Error:", error);
      alert(error instanceof Error ? error.message : "Payment processing failed. Please try again.");
    }
  }

  dateFormat(date: Date) {
    return format(date, 'YYYY/MM/DD')
  }

  shortDateFormat(date: Date) {
    return format(date, 'MM/DD')
  }

  localNumber(number: number) {
    return new Intl.NumberFormat("ja-JP").format(number)
  }

  cardNumber() {
    if (this.cardLast4) {
      return `**** **** **** ${this.cardLast4}`;
    } else if (this.stripeToken) {
      return `**** **** **** ${this.stripeToken.last4}`
    }
    return `**** **** **** ${this.subscription && this.subscription.stripeCustomerDefaultCardNumber}`
  }

  cardDate() {
    if (this.cardExpMonth && this.cardExpYear) {
      const month = String(this.cardExpMonth).padStart(2, '0');
      const year = String(this.cardExpYear)
      return `${month}/${year}`;
    } else if (this.stripeToken) {
      return `${this.stripeToken.expMonth}/${this.stripeToken.expYear}`
    }
    return this.subscription && this.subscription.stripeCustomerDefaultCardExpiredAt
  }

  checkSubscriptionStatus() {
    console.log('Checking subscription status...');

    subscriptionState.checkSubscriptionStatus(
      this.$route.params.subscriptionId as any,
      this.subscriptionChangePlanId
    ).then((response) => {
      console.log('Subscription status:', response);
    })
  }
}
